import { useContext, useState, useEffect } from "react";
import { Modal, Box, Typography, TextField, InputAdornment } from "@mui/material";
import logingLogo from "../../assets/LogoSemFundo.png";
import Style from "./login.module.scss";
import { useNavigate } from "react-router-dom";
import EmailIcon from '@mui/icons-material/Email';
import KeyboardIcon from '@mui/icons-material/Keyboard';
import { AppProvider } from "../../ContextApi/AppProvider";
import { LoginServices } from "../../Services/LoginServices";
import { User } from "../../Models/User";
import DefaultLoader from "../../Components/Shared/DefaultLoader";

const loginService = new LoginServices();

export default function LoginPage()  {
  
  const contextApi = useContext(AppProvider);
  const navigate = useNavigate();
  const [email, setEmail] = useState("");
  const [recovery, setRecovery] = useState("");
  const [password, setPassword] = useState("");
  const [error, setError] = useState("");
  const [loading, setLoading] = useState(false);
  const [showModal, setShowModal] = useState(false);

  const user = { "login":"teste@teste.com", "password":"teste1234"};

  useEffect(() => {
    if (process.env.NODE_ENV === "development") {
      setEmail("wrpneus");
      setPassword("@wrpneus");
    }
  }, []);

  //const { setToken } = useContext(AuthorizeContext)

  const validate = (payload:any) => {
    if (payload.login === user.login){
      if (payload.password === user.password){
        contextApi.showMessage('Login efetuado com sucesso!', true, 'success');
        return true;
      }
    }
    return false;
  }
  const handleLogin = (e: any) => {
    setEmail(e.target.value);
  };

  const handlePassword = (e: any) => {
    setPassword(e.target.value);
  };

  const forgotPassword = async () => {
    setShowModal(true);
    setError("");
    setLoading(true);
    setLoading(false);
  };

  function login() {
    sessionStorage.clear();
    setLoading(true);
    const body: User = { 
      id: 0,
      nome: "",
      email: "",
      login: email,
      senha: password,
      papel: ""
    };
  
    const loginRequest = loginService.login('Api/Usuario/login', body);
  
    const timeout = new Promise((_, reject) =>
      setTimeout(() => {
        reject(new Error('Request timed out'));
        setLoading(false);
      }, 60000) // 60 seconds timeout
    );
  
    Promise.race([loginRequest, timeout])
      .then((response: any) => {
        if (response.status === 200) {
          setLoading(false);
          contextApi.setToken(response.data.token);
          contextApi.setUser(response.data.user)
          sessionStorage.setItem('Token', response.data.token);
          sessionStorage.setItem('User', JSON.stringify(response.data.loginUsuarioResponse));
          contextApi.showMessage('Login efetuado com sucesso!', true, 'success');
          navigate('/app/pedidos');
        }
      })
      .catch((error: any) => {
        if (error.message === 'Request timed out') {
          contextApi.showMessage('Erro ao realizar login, tente novamente!', true, 'error');
        } else {
          contextApi.showMessage(error.response?.data?.message || 'Erro ao realizar login, tente novamente!', true, 'error');
        }
        setLoading(false);
      });
  }
  
  const handleKeyDown = (e:any) => {
    if (e.key === "Enter") {
      e.preventDefault(); // Evita o envio padrão do formulário
      login();
    }
  };

  const handleRecoveryPassword = () => {
    setShowModal(false);
  };

  return (
    <>
        <Box sx={{ bgcolor: '#cfe8fc', height: '100vh' }} >
      <div className={Style.containerLogin}>
        <img src={logingLogo} alt="Logo WRPneus" className={Style.logo} />
        <form className={Style.form} onKeyDown={handleKeyDown}>
          <h1 className={Style.h1}>Login</h1>
          <p style={{color: 'white'}}>Para continuar, digite suas credenciais</p>
          <div className={Style.containerInput}>         
                <TextField
                  label= "Email"
                  id="email"
                  placeholder="Digite seu E-mail"
                  name="Email"
                  variant="standard"
                  type="text"
                  value={email}
                  className="custom-textfield"
                  onChange={handleLogin}
                  InputProps={{
                    startAdornment: (
                      <InputAdornment position="start">
                        <EmailIcon style={{color: 'white'}} />
                      </InputAdornment>
                    ),
                  }}
                />
             <div>
              <p className={error ? Style.error : Style.transparent}>
                Verifique o e-mail e tente novamente.
              </p>
            </div> 
          </div>

          <div className={Style.containerInput}>
                <TextField
                  label= 'Senha'
                  className="custom-textfield"                
                  name="Password"
                  type="password"
                  placeholder="Digite sua senha"
                  variant="standard"
                  value={password}
                  onChange={handlePassword}
                  InputProps={{
                    startAdornment: (
                      <InputAdornment position="start">
                        <KeyboardIcon style={{color: 'white'}} />
                      </InputAdornment>
                    ),
                  }}
                />
            <div className={Style.errorP}>
              <p className={error ? Style.errorPass : Style.transparent}>
                Verifique a senha e tente novamente.
              </p>
            </div>
          </div>

          <button
            className={Style.button}
            type="button"
            onClick={login}
            disabled={loading}
          >
            {loading ? 
                    <DefaultLoader
                    height="3em"
                    width="3em"
                    colors={['#F15923','#F15923','#F15923','#F15923','#F15923']}
                    textInfo="Realizando Login"
                    />
            : "Fazer login"}
          </button>
          <button
            className={Style.forgot}
            type="button"
            onClick={forgotPassword}
            disabled={loading}
          >
            Esqueci minha senha
          </button>
        </form>
      </div>
      </Box>
      <Modal
        open={showModal}
        onClose={() => {
          setShowModal(false);
        }}
      >
        <Box
          sx={{
            position: "absolute",
            top: "50%",
            left: "50%",
            transform: "translate(-50%, -50%)",
            width: 400,
            borderRadius: "25px",
            boxShadow: 24,
            p: 4,
            backgroundColor: "#2B292F",
            display: "flex",
            flexDirection: "column",
            justifyContent: "center",
          }}
        >
          <Typography
            sx={{
              position: "relative",
              display: "flex",
              right: "10px",
              justifyContent: "center",
              marginBottom: "5px",
            }}
          >
            <EmailIcon style={{color: '#F25A24'}}></EmailIcon>
          </Typography>
          <Typography variant="h6" component="h2" sx={{ color: "#C9C4D0" }}>
            Deseja realizar a recuperação de senha?
          </Typography>
          <Typography sx={{ mt: 2 }}>
            <div className={Style.modalActions}>
              <div style={{color: '#C9C4D0'}}>
                Você está prestes a iniciar o processo de recuperação de senha.
                Por favor, insira o endereço de e-mail associado à sua conta
                abaixo e clique em "Enviar". Enviaremos instruções por e-mail
                para que você possa recuperar o acesso à sua conta rapidamente.
              </div>
              <TextField
                  label= "Email"
                  id="email"
                  placeholder="Digite seu E-mail"
                  name="Email"
                  variant="standard"
                  type="text"
                  // value={login}
                  sx={{width: 400, marginTop: '1em',
                  ".MuiInputBase-input": {
                    color: 'white',
                    borderBottom: '2px solid #F25A24'
                    
                  },
                  ".MuiInputBase-root::after": {
                    color: 'white',
                    borderBottom: '2px solid #F25A24'
                    
                  },
                  ".MuiFormLabel-root.Mui-focused": {
                    color: '#F25A24'
                  },
                  ".MuiFormLabel-root": {
                    color: 'white'
                  }
                }}
                  onChange={(e: any) => setRecovery(e.target.value)}
                />
              <div className={Style.buttons}>
                <button
                  type="button"
                  className={Style.modalButton}
                  onClick={() => setShowModal(false)}
                >
                  Voltar
                </button>
                <button
                  type="button"
                  className={Style.modalButton}
                  onClick={() => handleRecoveryPassword()}
                >
                  Enviar
                </button>
              </div>
            </div>
          </Typography>
        </Box>
      </Modal>
    </>
  );
};
